import { render, staticRenderFns } from "./CardRecycledContent.vue?vue&type=template&id=6de8de06&scoped=true&"
import script from "./CardRecycledContent.vue?vue&type=script&lang=js&"
export * from "./CardRecycledContent.vue?vue&type=script&lang=js&"
import style0 from "./CardRecycledContent.vue?vue&type=style&index=0&id=6de8de06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de8de06",
  null
  
)

export default component.exports